import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class ProjectDownloadManagerStatusComponent extends Component {
  @service projectDownloadManager;

  get operations() {
    return this.projectDownloadManager.operations;
  }
}
